import styled from 'styled-components';
import { HelpTooltip } from '~/components';

export default styled(HelpTooltip)`
  margin-left: 0.5rem;
`;
